import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="text-8xl font-serif font-bold text-[#009B8F]/20 mb-4">404</div>
        <h1 className="text-3xl font-serif text-[#011E26] mb-4">Page Not Found</h1>
        <p className="text-slate-500 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-[#009B8F] hover:bg-[#00857a] text-white px-6 py-3 font-bold text-sm uppercase tracking-widest transition-colors rounded-lg"
          >
            <Home size={16} /> Go Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 border border-slate-300 text-slate-600 hover:bg-slate-50 px-6 py-3 font-bold text-sm uppercase tracking-widest transition-colors rounded-lg"
          >
            <ArrowLeft size={16} /> Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
